module.exports = __webpack_public_path__ + "img/emoji_12.64d6d2eb.png";